import { createSlice } from "@reduxjs/toolkit";
import {
  deleteVideoCategory,
  getVideoCategory,
  undoDeleteVideoCategory,
} from "./VideoCategory.api";

const videoCategorySlice = createSlice({
  name: "videoCategory",
  initialState: {
    videoCategory: [],
    loading: false,
    error: null,
    success: null,
    dataLimit: 0,
    currentPage: 0,
    totalPages: 0,
    totalData: 0,
  },
  reducers: {
    resetState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getVideoCategory.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getVideoCategory.fulfilled, (state, action) => {
      state.loading = false;
      state.videoCategory = action.payload;
      state.dataLimit = action.payload.meta?.limit || 10;
      state.currentPage = action.payload.meta?.page || 1;
      state.totalPages = action.payload.meta?.totalPages || 0;
      state.totalData = action.payload.meta?.total || 0;
    });
    builder.addCase(getVideoCategory.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(deleteVideoCategory.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(deleteVideoCategory.fulfilled, (state, action) => {
      const deletedId = action?.payload?.data?._id;
      if (state.videoCategory.data) {
        state.videoCategory.data = state.videoCategory.data.filter(
          (videoCategory) => {
            return videoCategory._id !== deletedId;
          }
        );
        state.loading = false;
      } else {
        console.error(
          "state.videoCategory.data is not an array:",
          state.videoCategory.data
        );
      }
      state.loading = false;
    });
    builder.addCase(deleteVideoCategory.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(undoDeleteVideoCategory.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(undoDeleteVideoCategory.fulfilled, (state, action) => {
      const undodeletedId = action.payload.data._id;

      if (state.videoCategory.data) {
        state.videoCategory.data = state.videoCategory.data.filter(
          (videoCategory) => {
            return videoCategory._id !== undodeletedId;
          }
        );
        state.loading = false;
      } else {
        console.error(
          "state.videoCategory.data is not an array:",
          state.videoCategory.data
        );
      }
      state.loading = false;
    });
    builder.addCase(undoDeleteVideoCategory.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export const { resetState } = videoCategorySlice.actions;
export default videoCategorySlice.reducer;
